import { curry, map, multiply, range } from 'ramda'

export default curry((from, to, step) =>
  map(multiply(step), range(0, 1 + Math.round((to - from) / step))),
)
